import usePassiveRedux from '@sift/resift/usePassiveRedux';
import useOrgChartSettingsFetch from './useOrgChartSettingsFetch';
import _get from 'lodash/get';
import * as Sift from '@sift/types';

function useOrgChartSettings(): {
  [P in keyof Sift.OrgChartSettings]-?: Sift.OrgChartSettings[P];
} {
  const config = usePassiveRedux((state: any) =>
    _get(state, 'configurations.user', {}),
  ) as Sift.Configuration;

  if (_get(window, ['appState', 'orgChartSettings'])) {
    return _get(window, ['appState', 'orgChartSettings']);
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [orgChartSettingsFetchResult] = useOrgChartSettingsFetch();
  const orgChartSettings = orgChartSettingsFetchResult as Sift.OrgChartSettings;

  const orgChartHighlightBy = _get(config, 'layouts.org-chart-highlight-by') || [];
  const _highlightField = _get(orgChartSettings, 'highlightField', null) as string;
  const highlightField = (orgChartHighlightBy
    .map((item: any) => item.name)
    .includes(_highlightField)
    ? _highlightField
    : null) as string;

  return { ...orgChartSettings, highlightField };
}

export default useOrgChartSettings;
